import { formatTax } from './chunk-22INMNZK.mjs';
import { i18n_config_default } from './chunk-EJ2TIXJU.mjs';
import { __spreadValues, __spreadProps } from './chunk-T36PI2YV.mjs';
import cloneDeep from 'lodash/cloneDeep';
import max from 'lodash/max';

var deleteTaxTableRow = (currentData, taxId, id) => {
  const clonedTaxes = cloneDeep(currentData);
  const clonedTableTypeData = __spreadValues({}, clonedTaxes[taxId].tableTypeData);
  delete clonedTableTypeData[id];
  const clonedTableTypeDataEntries = Object.entries(clonedTableTypeData).sort(
    ([idA], [idB]) => Number(idA) - Number(idB)
  );
  clonedTableTypeDataEntries.forEach(([, tax], index) => {
    var _a;
    const prevTax = (_a = clonedTableTypeDataEntries[index - 1]) == null ? void 0 : _a[1];
    if (clonedTableTypeDataEntries.length > 1 && index + 1 > clonedTableTypeDataEntries.length) {
      return;
    }
    if (index === 0) {
      tax.from = 0;
      return;
    }
    const newFrom = max([prevTax ? prevTax.to + 0.01 : 0, (prevTax == null ? void 0 : prevTax.from) || 0]) || 0;
    tax.from = newFrom;
  });
  return __spreadProps(__spreadValues({}, clonedTaxes), {
    [taxId]: __spreadProps(__spreadValues({}, clonedTaxes[taxId]), {
      tableTypeData: clonedTableTypeData
    })
  });
};
var generateTaxDescription = (taxType, typeData) => {
  const description = formatTax(taxType, typeData);
  return description === "N/A" ? i18n_config_default.t("settingsModule.taxesSettings.taxesTable.taxTypes.table") : description;
};

export { deleteTaxTableRow, generateTaxDescription };
